import React from "react";
import "./App.css";
import { Route, Routes } from "react-router";
import HomePage from "./Pages/HomePage";
import TrackPage from "./Pages/TrackPage";
import QuotePage from "./Pages/QoutePage";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" exact element={<HomePage />} />
        <Route path="/track" exact element={<TrackPage />} />
        <Route path="/quote" exact element={<QuotePage />} />
      </Routes>
    </>
  );
}

export default App;
